// child inputs that addressFields maps to one of these get filled by the address autocomplete
export const ADDRESS_KEYS = ['countryCode', 'addressLine1', 'addressLine2', 'street', 'houseNumber', 'flatNumber', 'postalCode', 'city', 'region'] as const

export type AddressKey = typeof ADDRESS_KEYS[number]

export type AddressSuggestion = Partial<Record<AddressKey, string | null>>

export type SearchPosition = 'AFTER_COUNTRY' | 'TOP'

export const addressSuggestionText = (suggestion: AddressSuggestion): string => [
    suggestion.addressLine1 || [suggestion.street, suggestion.houseNumber].filter(Boolean).join(' '),
    suggestion.postalCode,
    suggestion.city,
].filter(Boolean).join(', ')
